// extracted by mini-css-extract-plugin
module.exports = {"location":"Location_location__7hyg9","title":"Location_title__1tCwc"};